function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M0 .73C0 .33.33 0 .73 0h5.65c.4 0 .73.33.73.73v5.65c0 .4-.32.73-.73.73H.73A.73.73 0 010 6.38V.73zm1.45.72v4.2h4.2v-4.2h-4.2zM8.9.73c0-.4.32-.73.73-.73h5.65c.4 0 .73.33.73.73v5.65c0 .4-.33.73-.73.73H9.62a.73.73 0 01-.73-.73V.73zm1.45.72v4.2h4.2v-4.2h-4.2zM0 9.62c0-.4.33-.73.73-.73h5.65c.4 0 .73.32.73.73v5.65c0 .4-.32.73-.73.73H.73a.73.73 0 01-.73-.73V9.62zm1.45.72v4.2h4.2v-4.2h-4.2zm7.44-.72c0-.4.32-.73.73-.73h5.65a.73.73 0 110 1.45h-3.9l4.42 4.42a.73.73 0 01-1.03 1.03l-4.42-4.42v3.9a.73.73 0 11-1.45 0V9.62z",
  clipRule: "evenodd"
});

function SvgAis3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAis3);
export default __webpack_public_path__ + "static/media/ais3.8b29062b.svg";
export { ForwardRef as ReactComponent };